import brandLogo from '../images/Logo_no_background.png';
import profileImage from '../images/Arya.png';
import '../styles/hero.css';

function HeroSection() {
  return (
    <header className="hero">
      <div className="hero-content">
        <img className="brand-logo" src={brandLogo} alt="Arya Eisa logotyp" />
        <p className="hero-overline">Dataingenjör · Projektledare · Affärsutvecklare</p>
        <h1>Arya Eisa</h1>
        <p className="hero-lead">
          Jag bygger datadrivna lösningar med fokus på tydlig affärsnytta, struktur och hållbar
          leverans.
        </p>

        <nav className="hero-cta" aria-label="Snabblänkar">
          <a className="hero-cta-primary" href="#kontakt">
            Hör av dig
          </a>
          <a className="hero-cta-secondary" href="#projekt">
            Se mina uppdrag
          </a>
        </nav>

        <div className="hero-links">
          <a href="https://linkedin.com/in/aryaeisa" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.94 8.5H3.56V20h3.38V8.5zm.22-3.54A1.96 1.96 0 0 0 5.2 3a1.96 1.96 0 0 0-1.97 1.96c0 1.08.88 1.95 1.97 1.95 1.08 0 1.96-.87 1.96-1.95zM20.44 13.4c0-3.13-1.67-4.58-3.9-4.58-1.8 0-2.6.99-3.05 1.68V8.5h-3.38c.04 1.32 0 11.5 0 11.5h3.38v-6.42c0-.34.02-.68.12-.92.27-.68.88-1.39 1.9-1.39 1.34 0 1.88 1.02 1.88 2.5V20h3.38v-6.6z" />
            </svg>
            <span className="sr-only">LinkedIn</span>
          </a>
          <a href="mailto:aryapoureisa@gmail.com" aria-label="Skicka e-post">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 6.75A2.75 2.75 0 0 1 5.75 4h12.5A2.75 2.75 0 0 1 21 6.75v10.5A2.75 2.75 0 0 1 18.25 20H5.75A2.75 2.75 0 0 1 3 17.25V6.75zm2.2-.25L12 11.36l6.8-4.86H5.2zm13.3 2.36l-5.96 4.26a1 1 0 0 1-1.16 0L5.5 8.86v8.39c0 .14.11.25.25.25h12.5a.25.25 0 0 0 .25-.25V8.86z" />
            </svg>
            <span className="sr-only">E-post</span>
          </a>
          <a href="tel:+46762316606" aria-label="Ring telefonnummer">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.62 10.79a15.5 15.5 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.32.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.4 21 3 13.6 3 4a1 1 0 0 1 1-1h3.49a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.24 1.02l-2.2 2.2z" />
            </svg>
            <span className="sr-only">Telefon</span>
          </a>
        </div>
      </div>

      <figure className="hero-image-wrap">
        <img className="hero-image" src={profileImage} alt="Porträtt av Arya Eisa" />
      </figure>
    </header>
  );
}

export default HeroSection;
